export enum MessageType {
  PLANE = 0,
  SYSTEM = 1,
  ADMIN = 2,
}

export enum SystemMessageType {
  CREATE_ROOM,
  CLEAN_ROOM,
  GIFT_BULLET,
  JOIN_USER,
  PICK,
  PICK_RESULT,
}

export interface UserDetail {
  id: string;
  nickname: string;
  level: number;
  hasThumbnail: boolean;
  todayComment: string;
}

export interface Message {
  user: string;
  messageType: MessageType;
  contents: string | { systemMessageType: SystemMessageType };
}